// @flow
import { all, fork, put, takeEvery, call } from 'redux-saga/effects';

import {
    getCategoriasEnlaces as listCategoriasEnlacesAPI,
    getCategoriaEnlaces as getCategoriaEnlacesAPI,
    addCategoriaEnlaces as addCategoriaEnlacesAPI,
    updateCategoriaEnlaces as updateCategoriaEnlacesAPI,
    deleteCategoriaEnlaces as deleteCategoriaEnlacesAPI,
} from '../../helpers/';

// import { APICore, setAuthorization } from '../../helpers/api/apiCore';
import { categoriasEnlacesApiResponseError, categoriasEnlacesApiResponseSuccess } from './actions';
import { CategoriasEnlacesActionTypes } from './constants';

// const api = new APICore();

/**
 * Get contacto
 * @param {*} payload - username and password
 */
function* getCategoriaEnlaces({ payload: { id } }) {
    try {
        const response = yield call(getCategoriaEnlacesAPI, id );
        const categoriaItem = response.data.data;
        yield put(categoriasEnlacesApiResponseSuccess(CategoriasEnlacesActionTypes.GET_CATEGORIA_ENLACES, categoriaItem));
    } catch (error) {
        yield put(categoriasEnlacesApiResponseError(CategoriasEnlacesActionTypes.GET_CATEGORIA_ENLACES, error));
    }
}

function* addCategoriaEnlaces({payload:categoria}){
    try{
        const response = yield call(addCategoriaEnlacesAPI,{...categoria})
        const categoriaItem = response.data
        yield put(categoriasEnlacesApiResponseSuccess(CategoriasEnlacesActionTypes.ADD_CATEGORIA_ENLACES,categoriaItem))
    } catch(error){
        yield put(categoriasEnlacesApiResponseError(CategoriasEnlacesActionTypes.ADD_CATEGORIA_ENLACES,error))
    }
}

function* updateCategoriaEnlaces({payload:categoria}){
    try{
        const response = yield call(updateCategoriaEnlacesAPI,{...categoria})
        const categoriaItem = response.data.data
        yield put(categoriasEnlacesApiResponseSuccess(CategoriasEnlacesActionTypes.UPDATE_CATEGORIA_ENLACES,categoriaItem))
    }catch(error){
        yield put(categoriasEnlacesApiResponseError(CategoriasEnlacesActionTypes.UPDATE_CATEGORIA_ENLACES,error))
    }
}
function* deleteCategoriaEnlaces({payload:{id}}){
    try{
        const response = yield call(deleteCategoriaEnlacesAPI,id)
        const categoriaItem = response.data.id
        yield put(categoriasEnlacesApiResponseSuccess(CategoriasEnlacesActionTypes.DELETE_CATEGORIA_ENLACES,categoriaItem))
    }catch(error){
        yield put(categoriasEnlacesApiResponseError(CategoriasEnlacesActionTypes.DELETE_CATEGORIA_ENLACES,error))
    }
}

/**
 * List contactos
 */
function* listCategoriasEnlaces({payload:params}) {
    try {
        const response = yield call(listCategoriasEnlacesAPI, { ...params });
        const listaCategorias = response.data.data;
        yield put(categoriasEnlacesApiResponseSuccess(CategoriasEnlacesActionTypes.LIST_CATEGORIAS_ENLACES, listaCategorias));
    } catch (error) {
        yield put(categoriasEnlacesApiResponseError(CategoriasEnlacesActionTypes.LIST_CATEGORIAS_ENLACES, error));
    }
}


export function* watchGetCategoriaEnlaces(): any {
    yield takeEvery(CategoriasEnlacesActionTypes.GET_CATEGORIA_ENLACES, getCategoriaEnlaces);
}

export function* watchListCategoriasEnlaces(): any {
    yield takeEvery(CategoriasEnlacesActionTypes.LIST_CATEGORIAS_ENLACES, listCategoriasEnlaces);
}

export function* watchAddCategoriaEnlaces():any{
    yield takeEvery(CategoriasEnlacesActionTypes.ADD_CATEGORIA_ENLACES,addCategoriaEnlaces)
}
export function* watchUpdateCategoriaEnlaces():any{
    yield takeEvery(CategoriasEnlacesActionTypes.UPDATE_CATEGORIA_ENLACES,updateCategoriaEnlaces)
}
export function* watchDeleteCategoriaEnlaces():any{
    yield takeEvery(CategoriasEnlacesActionTypes.DELETE_CATEGORIA_ENLACES,deleteCategoriaEnlaces)
}


function* categoriasEnlacesSaga(): any {
    yield all([
        fork(watchGetCategoriaEnlaces),
        fork(watchListCategoriasEnlaces),
        fork(watchAddCategoriaEnlaces),
        fork(watchUpdateCategoriaEnlaces),
        fork(watchDeleteCategoriaEnlaces),
    ]);
}

export default categoriasEnlacesSaga;
